import apiClient from "../../services/apiClient";

export async function fetchWorksheetsAPI(
  page = 1,
  limit = 10,
  type = null,
  keyword = null
) {
  let url = `/api/v1/worksheets?limit=${limit}&page=${page}`;

  // If type is not null, add it as a query parameter
  if (type !== null) {
    url += `&type=${encodeURIComponent(type)}`;
  }

  if (keyword !== null) {
    url += `&search_keyword=${keyword}`;
  }

  const response = await apiClient.get(url, { withAuth: true });
  return response.data;
}

export async function fetchAssignedWorksheetsAPI(
  page = 1,
  limit = 10,
  type = null,
  keyword = null
) {
  let url = `/api/v1/worksheets/assigned?limit=${limit}&page=${page}`;

  // If type is not null, add it as a query parameter
  if (type !== null) {
    url += `&type=${encodeURIComponent(type)}`;
  }

  if (keyword !== null) {
    url += `&keyword=${encodeURIComponent(keyword)}`;
  }

  const response = await apiClient.get(url, { withAuth: true });
  return response.data;
}

export async function updateAssignedWorksheetsAPI(worksheetId, data) {
  if (!worksheetId) {
    throw new Error("Worksheet ID is required");
  }
  let url = `/api/v1/worksheets/assigned?worksheet_id=${worksheetId}`;
  const response = await apiClient.put(url, data, {
    withAuth: true,
  });
  return response.data;
}

export async function retrieveWorksheetAPI(id, type) {
  console.log(`Fetching worksheet - type: ${type}, id: ${id}`);
  const response = await apiClient.get(
    `/api/v1/worksheets/retrieve?type=${type}&id=${id}`,
    { withAuth: true }
  );
  console.log("Worksheet API response:", response);
  console.log("Worksheet data:", response.data);
  return response.data;
}

export async function createAssignmentAPI(data) {
  const response = await apiClient.post("/api/v1/assignment/create", data, {
    withAuth: true,
  });
  return response.data;
}

export async function updateAssignmentAPI(data) {
  const response = await apiClient.post("/api/v1/assignment/update", data, {
    withAuth: true,
  });
  return response.data;
}

export async function deleteAssignedWorksheetAPI(id) {
  const response = await apiClient.delete(
    `/api/v1/worksheets/delete?id=${id}`,
    {
      withAuth: true,
    }
  );
  return response.data;
}

export async function fetchAssignmentListAPI(
  page,
  limit,
  type,
  isFinished,
  levelId,
  keyword,
  studentId,
  studentGrade,
  userId = null,
  isRetry = null
) {
  let url = `/api/v1/assignment/list/teacher?page=${page}&limit=${limit}`;

  if (isRetry !== null) {
    url += `&is_retry=${isRetry}`;
  }

  if (type !== null) {
    url += `&type=${type}`;
  }
  if (isFinished !== null) {
    url += `&is_finished=${isFinished}`;
  }
  if (levelId !== null) {
    url += `&level_id=${levelId}`;
  }
  if (keyword !== null) {
    url += `&keyword=${keyword}`;
  }
  if (studentId !== null) {
    url += `&student_id=${studentId}`;
  }
  if (studentGrade !== null) {
    url += `&grade=${studentGrade}`;
  }
  if (userId !== null) {
    url += `&user_id=${userId}`;
  }

  const response = await apiClient.get(url, {
    withAuth: true,
  });
  return response.data;
}

export async function retrieveCommentaryPDFAPI(assignmentId, studentId) {
  const response = await apiClient.get(
    `/api/v1/assignment/pdf/commentary?assignment_id=${assignmentId}&student_id=${studentId}`,
    { responseType: "blob" }
  );
  return response;
}

export async function deleteAssignmentAPI(id) {
  const response = await apiClient.delete(
    `/api/v1/assignment/delete?id=${id}`,
    {
      withAuth: true,
    }
  );
  return response.data;
}

export async function createRetryAssignmentAPI(assignmentId, maxRetries = 3) {
  const response = await apiClient.post(
    `/api/v1/assignment/retry?assignment_id=${assignmentId}&max_retries=${maxRetries}`,
    {},
    {
      withAuth: true,
    }
  );
  return response.data;
}

export async function retrieveVocabularyRetryPDFAPI(assignmentId, studentId, retryType = "test") {
  const response = await apiClient.get(
    `/api/v1/assignment/pdf/vocabulary-retry?assignment_id=${assignmentId}&student_id=${studentId}&retry_type=${retryType}`,
    { responseType: "blob" }
  );
  return response;
}

export async function retrieveVocabularyWordbookPDFAPI(assignmentId, studentId) {
  const response = await apiClient.get(
    `/api/v1/assignment/pdf/vocabulary-retry?assignment_id=${assignmentId}&student_id=${studentId}&retry_type=wordbook`,
    { responseType: "blob" }
  );
  return response;
}
